import React from "react";
import profile from "../../assets/uicon.png";
import facebook from '../../assets/facebook.png';
import instagram from '../../assets/instagram.png'
import twitter from '../../assets/twitter.png'
import '../../css/homepage.css';

const UserAdmin = ({values}) => {
  return (
      <div className="bg-transparent px-5">
        <h1 className="lg:ml-20 font-semibold text-3xl pb-10 title">My Profile</h1>
          <div className="flex">
            <div className="flex ml-20 space-x-3 w-fit my-10 bg-[#434242] items-center text-sm shadow-inner py-2 px-4 rounded-sm">
              {values?.businessLogoUrl ? (
              <>
                <img
                  src={values?.businessLogoUrl}
                  alt="profile"
                  className="w-20 h-20"
                />
              </>
              ) : (
              <img src={profile} alt="profile" className="w-20 h-20" />
              )}
            </div>
            <button className="hidden mx-10 my-20 text-black bg-[#F3EFE0] justify-center items-center w-fit cursor-pointer p-3 font-medium text-center rounded-3xl text-sm">Change profile Pic</button>
          </div>
          <div>
              <form className="grid grid-cols-2 gap-10 lg:ml-20 lg:mr-80">
                <div>
                  <label className="text-sm font-normal py-2 leading-4 text-white">Full Name</label>
                  <input className="py-2 w-full p-2 text-sm" readOnly value={values?.name}/>
                </div>
                <div>
                  <label className="text-sm font-normal py-2 leading-4 text-white">Website</label>
                  <input className="py-2 w-full p-2 text-sm" />
                </div>
                <div className="col-span-2">
                  <label className="text-sm font-normal py-2 leading-4 text-white">Email Address</label>
                  <input className="py-2 w-full p-2 text-sm" readOnly value={values?.email}/>
                </div>
                <div>
                  <label className="text-sm font-normal py-2 leading-4 text-white">Phone number</label>
                  <input className="py-2 w-full p-2 text-sm" readOnly value={values?.phone}/>
                </div> 
                <div>
                  <label className="text-sm font-normal py-2 leading-4 col-span-2 text-white">Socials</label>
                  <img src={twitter} alt='twittericon' className="bg-white"/><input className="py-2 w-full p-2 text-sm" readOnly value={values?.twitter}/>
                  <img src={instagram} alt='twittericon'/><input className="py-2 w-full p-2 text-sm"/>
                  <img src={facebook} alt='twittericon'/><input className="py-2 w-full p-2 text-sm"/>
                </div>
                <button className='col-span-2 px-4 rounded-sm py-2 my-3 hidden'>Save changes</button>
              </form>
          </div>
      </div>
  );
};

export default UserAdmin;
